import logo from "@/assets/logo.webp";

const Footer = () => {
  return <footer className="bg-[hsl(215,100%,8%)] text-white py-12">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Wave Divider */}
        <div className="mb-12">
          <svg className="w-full h-12 opacity-20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80">
            <path fill="hsl(193, 100%, 42%)" d="M0,32L48,37.3C96,43,192,53,288,56C384,59,480,53,576,48C672,43,768,37,864,37.3C960,37,1056,43,1152,45.3C1248,48,1344,48,1392,48L1440,48L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z" />
          </svg>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <img src={logo} alt="FoundryWave" className="h-10 w-auto brightness-0 invert mb-4" />
            <p className="text-white/70 mb-4 max-w-md">
              Building the future, one small business at a time. AI-first websites, CRMs, and automation systems that make small businesses run like big ones.
            </p>
            <p className="text-sm text-white/50 mb-4">
              Powered by <a href="https://smallbiz.com" className="text-primary hover:text-primary/80">SmallBiz.com</a>
            </p>
            {/* Business contact details — A2P 10DLC brand verification requires the
                registered address, email and phone to be visible on the site. */}
            <address className="not-italic text-sm text-white/50 space-y-1">
              <p>Breaking Free Services LLC · PO Box 1195, Middletown, DE 19709</p>
              <p>
                <a href="mailto:hey@foundrywave.studio" className="hover:text-primary transition-colors">hey@foundrywave.studio</a>
                {" · "}
                <a href="tel:+13024499422" className="hover:text-primary transition-colors">+1 302-449-9422</a>
              </p>
            </address>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white/70">
              <li>
                <a href="#services" className="hover:text-primary transition-colors">Services</a>
              </li>
              <li>
                <a href="#about" className="hover:text-primary transition-colors">About</a>
              </li>
              <li>
                <a href="#testimonials" className="hover:text-primary transition-colors">Case Studies</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-primary transition-colors">Contact</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-white/70">
              <li>
                <a href="/ai-automation-agency" className="hover:text-primary transition-colors">AI Automation Agency</a>
              </li>
              <li>
                <a href="/ai-automation-consultant" className="hover:text-primary transition-colors">AI Automation Consultant</a>
              </li>
              <li>
                <a href="/business-automation-services" className="hover:text-primary transition-colors">Business Automation</a>
              </li>
              <li>
                <a href="/workflow-automation-services" className="hover:text-primary transition-colors">Workflow Automation</a>
              </li>
              <li>
                <a href="/ai-website-optimization" className="hover:text-primary transition-colors">AI Website Optimization</a>
              </li>
            </ul>
          </div>
        </div>


        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © {new Date().getFullYear()} FoundryWave. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-white/50">
            <a href="/privacy" className="hover:text-primary transition-colors">Privacy Policy</a>
            <a href="/terms" className="hover:text-primary transition-colors">Terms of Service</a>
            <a href="https://www.linkedin.com/company/foundrywave-studio" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" aria-label="LinkedIn">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;